"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketEncryptionInput_1 = require("./PutBucketEncryptionInput");
var PutBucketEncryptionOutput_1 = require("./PutBucketEncryptionOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketEncryption = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketEncryption",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?encryption"
    },
    input: {
        shape: PutBucketEncryptionInput_1.PutBucketEncryptionInput
    },
    output: {
        shape: PutBucketEncryptionOutput_1.PutBucketEncryptionOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketEncryption.js.map